import React from 'react';

const CloseButtonToaster = () => {
  return <button className="Toastify__close-button Toastify__close-button--light" type="button" aria-label="close">
    ✖
  </button>;
};

export default CloseButtonToaster;
